import React from "react";
import { useParams } from "react-router-dom";
import ServiceLandingPage from "./ServiceLandingPage";
import ServiceRoutePage from "./ServiceRoutePage";
import { findService } from "./serviceData";

const ServicePage = () => {
  const { categorySlug, serviceSlug, subCategorySlug } = useParams();
  const service = findService(categorySlug, serviceSlug);
  if (!subCategorySlug && service?.singlePage) {
    return <ServiceRoutePage />;
  }

  const isDirectRoute = service?.routes?.some(
    (route) => route.slug === subCategorySlug,
  );

  return isDirectRoute ? <ServiceRoutePage /> : <ServiceLandingPage />;
};

export default ServicePage;
